// extracted by mini-css-extract-plugin
export default {"pageBreak":"style_pageBreak__NrL98","printHide":"style_printHide__vSBWd"};